/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ai_Import_Settings_TitleInputs */



/**
* | output |
* | --- |
* | "Confirm Import Settings" |
*
* @param {Ai_Import_Settings_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ai_import_settings_title = /** @type {((inputs?: Ai_Import_Settings_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ai_Import_Settings_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Confirmer les paramètres d'importation")
	if (locale === "de") return /** @type {LocalizedString} */ ("Importeinstellungen bestätigen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Conferma impostazioni di importazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Подтвердите параметры импорта")
	if (locale === "es") return /** @type {LocalizedString} */ ("Confirmar la configuración de importación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("确认导入设置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("インポート設定の確認")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आयात सेटिंग्स की पुष्टि करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Confirmar definições de importação")
	return /** @type {LocalizedString} */ ("Confirm Import Settings")
});